<form [formGroup]="pricingForm" (ngSubmit)="save()" class="pricing-settings-form">
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="dutyAmount" placeholder="DUTY">
    <mat-hint>Flat fee added to Custom when duty is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="nosepadsInstallAmount" placeholder="NOSEPADS INSTALL">
    <mat-hint>Flat fee added to Custom when nosepads install is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="drillMountAmount" placeholder="DRILL MOUNT">
    <mat-hint>Flat fee added to Custom when drill mount is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <input matInput type="number" min="0" max="100" step="0.01" formControlName="restockingFeePercent" placeholder="RESTOCKING FEE %">
    <span matSuffix>&nbsp;%</span>
    <mat-hint>Default restocking fee applied on RETURN. Opticians can waive it per return.</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <input matInput type="number" min="0" max="100" step="0.01" formControlName="salesTaxRate" placeholder="SALES TAX %">
    <span matSuffix>&nbsp;%</span>
    <mat-hint>Applied to taxable line items after discounts. Postage is not discounted. Leave 0 to use the TAX amount entered on the order.</mat-hint>
  </mat-form-field>

  <div class="materials-section" formArrayName="materials">
    <div class="materials-header">
      <h3 class="materials-title">MATERIALS</h3>
      <button mat-stroked-button type="button" (click)="addMaterial()">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Options appear in the Material dropdown on Add Order. Selected material price is added to Custom.
    </p>

    <div
      class="material-row"
      *ngFor="let material of materials.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="material-price-field">
        <mat-label>PRICE</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input
          matInput
          type="text"
          inputmode="decimal"
          formControlName="price"
          autocomplete="off"
          (blur)="formatMaterialPrice(i)"
        >
      </mat-form-field>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove material option"
        (click)="removeMaterial(i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="materials-empty" *ngIf="!materials.length">
      No material options yet. Click ADD OPTION to create one.
    </div>
  </div>

  <div class="materials-section" formArrayName="repairLocations">
    <div class="materials-header">
      <h3 class="materials-title">REPAIR LOCATIONS</h3>
      <button mat-stroked-button type="button" (click)="addListOption('repairLocations')">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Used on Repair Tasks. Removing an option hides it from future jobs and does not change historical repairs.
    </p>
    <div
      class="material-row"
      *ngFor="let option of repairLocations.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-checkbox formControlName="active">ACTIVE</mat-checkbox>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove repair location"
        (click)="removeListOption('repairLocations', i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="materials-section" formArrayName="whoToCallOptions">
    <div class="materials-header">
      <h3 class="materials-title">WHO TO CALL</h3>
      <button mat-stroked-button type="button" (click)="addListOption('whoToCallOptions')">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Used on CALL / RX. Historical jobs keep the originally selected value.
    </p>
    <div
      class="material-row"
      *ngFor="let option of whoToCallOptions.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-checkbox formControlName="active">ACTIVE</mat-checkbox>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove who to call option"
        (click)="removeListOption('whoToCallOptions', i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <mat-form-field style="width:100%;">
    <input matInput type="number" min="1" step="1" formControlName="inquiryFollowUpHours" placeholder="INQUIRY FOLLOW-UP HOURS">
    <mat-hint>Hours before an unresolved Inquiry surfaces in TO DO TODAY. Default 24.</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <input matInput type="number" min="1" step="1" formControlName="awaitingRxFollowUpHours" placeholder="AWAITING RX FOLLOW-UP HOURS">
    <mat-hint>Hours before a missing RX surfaces as FOLLOW UP / RX. Default 24.</mat-hint>
  </mat-form-field>

  <button mat-raised-button type="submit" [disabled]="pricingForm.invalid || saving">SAVE</button>
</form>
